import React from "react";

import type { ClientConfig } from "@blis/config";

import { getApiUrl } from "./api";

const ConfigContext = React.createContext<ClientConfig | null>(null);

let clientConfig: ClientConfig | null = null;

export async function fetchConfig(): Promise<ClientConfig> {
  if (clientConfig) {
    return clientConfig;
  }
  const res = await fetch(getApiUrl("/api/config"));
  clientConfig = await res.json();
  return clientConfig as ClientConfig;
}

export function useConfig() {
  const config = React.useContext(ConfigContext);
  if (!config) {
    throw new Error("useConfig must be used within a ConfigProvider");
  }
  return config;
}

export function ConfigProvider({
  children,
  config,
}: {
  children: React.ReactNode;
  config: ClientConfig;
}) {
  return (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
  );
}
